import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const SeriesPage = lazy(() => import('@/pages/content/series/SeriesPage'))
const SeriesAddPage = lazy(() => import('@/pages/content/series/SeriseAddPage'))
const SeriesTabPage = lazy(() => import('@/pages/content/series/page'))
const EpisodePage = lazy(() => import('@/pages/content/episode/EpisodePage'))
const EpisodeAddPage = lazy(() => import('@/pages/content/series/episode/EpisodeAddPage'))
const EpisodeDetailPage = lazy(() => import('@/pages/content/series/episode/EpisodeDetailPage'))
// const EpisodeDetailPage = lazy(() => import('@/pages/content/series/episode/Ep2'))

const AlbumPage = lazy(() => import('@/pages/content/album/AlbumPage'))
const AlbumAddPage = lazy(() => import('@/pages/content/album/AlbumAddPage'))
const AlbumTapPage = lazy(() => import('@/pages/content/album/AlbumTapPage'))
const MusicAddPage = lazy(() => import('@/pages/content/music/MusicAddPage'))
const MusicDetailPage = lazy(() => import('@/pages/content/music/MusicDetailPage'))

/**
 * 콘텐츠 관리 라우트
 * - 보이스툰 (시리즈, 에피소드)
 * - 뮤직 (앨범, 수록곡)
 */
export const contentRoutes: RouteWithMeta = {
  path: 'contents',
  meta: {
    label: '콘텐츠',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 보이스툰 =====
    {
      path: 'series',
      element: withSuspense(<SeriesPage/>),
      meta: {
        label: '보이스툰',
        showInMenu: true,
      }
    },
    {
      path: 'series/add',
      element: withSuspense(<SeriesAddPage/>),
      meta: {
        label: '보이스툰 등록',
        showInMenu: false,
      }
    },
    {
      path: 'series/:id',
      element: withSuspense(<SeriesTabPage/>),
      meta: {
        label: '보이스툰 상세',
        showInMenu: false
      }
    },
    {
      path: 'series/:seriesId/episodes/add',
      element: withSuspense(<EpisodeAddPage/>),
      meta: {
        label: '보이스툰(에피소드) 등록',
        showInMenu: false,
      }
    },
    {
      path: 'series/:seriesId/episodes/:id',
      element: withSuspense(<EpisodeDetailPage/>),
      meta: {
        label: '보이스툰(에피소드) 상세',
        showInMenu: false
      }
    },
    {
      path: 'episodes',
      element: withSuspense(<EpisodePage />),
      meta: {
        label: '전체 에피소드 조회용',
        showInMenu: true
      }
    },

    // ===== 뮤직 =====
    {
      path: 'album',
      element: withSuspense(<AlbumPage/>),
      meta: {
        label: '뮤직',
        showInMenu: true,
      }
    },
    {
      path: 'album/add',
      element: withSuspense(<AlbumAddPage/>),
      meta: {
        label: '앨범 등록',
        showInMenu: false
      }
    },
    {
      path: 'album/:id',
      element: withSuspense(<AlbumTapPage/>),
      meta: {
        label: '앨범 상세',
        showInMenu: false
      }
    },
    {
      path: 'album/:albumId/music/add',
      element: withSuspense(<MusicAddPage/>),
      meta: {
        label: '수록곡 등록',
        showInMenu: false,
      }
    },
    {
      path: 'album/:albumId/music/:id',
      element: withSuspense(<MusicDetailPage/>),
      meta: {
        label: '수록곡 상세',
        showInMenu: false
      }
    },
  ]
}